export const pad2 = (n) => String(n).padStart(2, '0');

export const HOURS = Array.from({ length: 12 }, (_, i) => pad2(i + 1));

export const PERIODS = ['AM', 'PM'];

export const timeToMinutes = (time) => {
    if (!time) return null;

    const match = time.trim().match(/^(\d{1,2}):(\d{2})\s*([AaPp][Mm])$/);

    if (!match) return null;

    let hour = parseInt(match[1], 10);
    const minute = parseInt(match[2], 10);
    const period = match[3].toUpperCase();

    if (period === 'AM') {
        if (hour === 12) hour = 0;
    } else {
        if (hour !== 12) hour += 12;
    }

    return hour * 60 + minute;
};

export const isTimeGreater = (startTime, endTime) => {
    const start = timeToMinutes(startTime);

    const end = timeToMinutes(endTime);

    if (start === null || end === null) {
        return false;
    }

    return end > start;
};
